// vue-i18n's d() takes a Date, a timestamp or an ISO string and throws on anything else, and a throw there
// takes down the whole surrounding render, not just the one value. So an empty or invalid date gives '', and
// a date string in another format is parsed here first. ISO strings still go through vue-i18n's own parsing.
const ISO_DATE = /(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/

export function formatDate(date, format, d) {
    // moment(null) is invalid and still has a toDate()
    let value = (date?.toDate && date.toDate()) ?? date
    if (value === null || value === undefined || value === '') return ''
    if (typeof value === 'string' && !ISO_DATE.test(value)) value = new Date(value)
    if (!(value instanceof Date) && typeof value !== 'string' && typeof value !== 'number') return ''

    const time = value instanceof Date ? value.getTime() : new Date(value).getTime()
    return Number.isNaN(time) ? '' : d(value, format)
}
